var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"type":"submit","color":"primary","disabled":_vm.disabled || _vm.pending,"loading":_vm.pending},on:{"click":_vm.click}},[_vm._v("Save")])}
var staticRenderFns = []

export { render, staticRenderFns }